import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActivityInformation from './ActivityInformation';
import {
  downloadAMLSTMCommonActivityInfo,
  getAMLSTMCommonActivityInfo,
  getAMLSTMCommonTransactionTriggeredTypologies,
  getAMLSTMCommonTransactionTriggeredVariants,
  getAMLSTMCommonQueryFields
} from '../../../../redux/actions/tmCommon';
import { resolveAlertSourceId } from '../../../../util/framlP';

const mapStateToProps = (state, ownProps) => {
  const { alertPartyIdentity = {}, alertDetails = {} } = state.amlsCommon;
  // FIN-12019 — on the CM route the AMLS unified-alert endpoint has no row for
  // the CM-domain alert id, so amlsCommon.alertDetails (numeric alertSourceId) is
  // empty. The CM slice holds the source as a string label; use it as a fallback.
  const cmSourceLabel = state.cmAlertDetails?.alertDetails?.alert?.sourceId;
  const {
    activityInformation = {},
    activityInformationDownloaded = {},
    transactionTriggeredTypologies = {},
    // FIN-13578 — the activity grid reads its own list; the prop keeps its name.
    activityTriggeredVariants: transactionTriggeredVariants,
    queryFields: metaData
  } = state.amlsTMCommon;
  const { data: activityInfoData, error, isLoading } = activityInformation;
  const { data: customerInfo, isLoading: isCustomerInfoLoading } =
    alertPartyIdentity;
  const { data: primaryPartyKeyInfo } = alertDetails;
  const { primaryPartyKey = '' } = primaryPartyKeyInfo || {};
  const { partyKey = '' } = customerInfo || {};
  const {
    data: activityInformationDownloadedData,
    isLoading: isDownloadingActivity = false
  } = activityInformationDownloaded;
  const { data: typologies } = transactionTriggeredTypologies;
  const { data: queryFields } = metaData || {};

  return {
    activityInfoData,
    activityInformationDownloaded: activityInformationDownloadedData,
    isDownloadingActivity,
    error,
    isLoading,
    isCustomerInfoLoading,
    // FIN-11398 — customer-scoped mounts (FRAML customer-detail) pass an explicit
    // customerId own-prop; it wins over the alert-derived party key. Alert-detail
    // mounts never pass it, so their behaviour is unchanged.
    customerId: ownProps.customerId || primaryPartyKey || partyKey,
    alertDetails,
    transactionTriggeredVariants,
    typologies,
    queryFields,
    // FIN-11542 — pass alertSourceId for variant facet gating in ActivityInfoFilters
    // FIN-12019 — fall back to the CM string source label on the CM route
    alertSourceId: resolveAlertSourceId(
      primaryPartyKeyInfo?.alertSourceId,
      cmSourceLabel
    )
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSTMCommonActivityInfo,
        downloadAMLSTMCommonActivityInfo,
        getAMLSTMCommonTransactionTriggeredTypologies,
        getAMLSTMCommonTransactionTriggeredVariants,
        getAMLSTMCommonQueryFields
      },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityInformation);
